// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"09e5984d","239":"ab8d0933","453":"6c372c44","667":"8349712f"}[chunkId] + ".chunk.js";
};